import styled from "styled-components";
import {animations, colors, devices, sizes} from "../../utils/styled/_variables.styled";
import {KoerberLanguageSelectorWrapper} from "../LanguageSelector/LanguageSelector.style";
import "../../base/styled/_typograhpy.style";

export const FooterLanguageWrapper = styled.div`
    position: relative;
    display: flex;
    margin: 0 24px 41px;
    max-height: 25px;

    @media ${devices.tabletLarge} {
        margin: 0px 26px 36px;
      }

    @media ${devices.mobile} {
        margin: 0px 16px 36px;
      }

    .label-medium {
      @media ${devices.tabletLarge}, ${devices.mobile} {
        display: grid;
      }
    }

    ${KoerberLanguageSelectorWrapper} {
      margin-left: 0;
    }

    .select {
      &__menu {
        display: flex;
        position: absolute;
        z-index: 200;
        top: 20px;
        left: 10px;
        height: auto;

        @media ${devices.tabletLarge}, ${devices.mobile} {
          display: grid;
          bottom: 20px;
          width: 100%;
          min-width: 93px;
          top: auto;
      }
    }

    &__control {
      &:hover {
        .select__single-value {
          transition: ${animations.buttonLink};
          color: ${colors.blueHover};
          opacity: 1;
        }  
        svg {
            opacity: 1;
            path {
              transition: ${animations.buttonLink};
              fill: ${colors.blueHover};
            }
        }
      }
      &:active {
          color: ${colors.bluePressed};

          svg {
              path {
                  fill: ${colors.bluePressed}
              }
          }
        }
    }
  }
`;

const FooterBar = styled.footer`
  min-height: 324px;
  background: ${colors.black};
  position: relative;
  overflow: hidden;
  
  
  @media ${devices.desktop} {
    padding-left: 96px;
    padding-right: 96px;
  }
  
  @media ${devices.tablets} {
    padding-left: 48px;
    padding-right: 48px;
  }

  @media ${devices.mobile} {
    padding-left: 24px;
    padding-right: 24px;
  }

  .footer {
    &__content {
      margin-right: auto;
      margin-left: auto;
      max-width: ${sizes.desktop - 1}px;
    }

    &__elements {
      min-height: 143px;
      display: flex;
      flex-wrap: wrap;
      margin: 0px 0px 43px;
      padding-top: 64px;
      row-gap: 44px;

      @media ${devices.tabletLarge} {
        display: grid;
        margin: 0px 0px 40px 12px;
        row-gap: 40px;
        padding-top: 56px;
      }

      @media ${devices.mobile} {
        display: grid;
        margin: 0px 0px 36px 8px;
        row-gap: 36px;
        padding-top: 48px;
      }

      .footer__logo {
        width: 54px;
        height: 32px;
        margin: 4px 40px 4px 32px;
        @media ${devices.tabletLarge} {
          margin: 0 0 0 24px;
        }
        @media ${devices.mobile} {
          margin: 0 0 0 16px;
        }
      }

      .container__links {
        display: flex;
        flex-wrap: wrap;
        margin-right: auto;
        column-gap: 40px;
        row-gap: 16px;

        @media ${devices.tabletLarge} {
          margin-left: 24px;
          column-gap: 36px;
        }

        @media ${devices.mobile} {
          display: grid;
          justify-items: flex-start;
          margin-left: 16px;
          a {
            white-space: break-spaces;
          }
        }
      }

      .container__social {
        display: flex;
        flex-wrap: wrap;
        column-gap: 20px;
        margin-left: 32px;
        @media ${devices.tabletLarge} {
          margin-left: 24px;
          column-gap: 16px;
        }
        @media ${devices.mobile} {
          margin-left: 16px;
          column-gap: 25.75px;
          row-gap: 24px;
        }

        a:hover{
          opacity: 1;
        }

        img {
          filter: grayscale(1) invert(1) brightness(2);
          transition: filter 0.5s;
          &:hover {
            opacity: 1;
            filter: none;
          }
        }
      }

      .container__sublinks {
        display: flex;
        flex-wrap: wrap;
        column-gap: 40px;
        margin-left: 32px;
        @media ${devices.tabletLarge} {
          margin-left: 24px;
          column-gap: 36px;
          row-gap: 20px;
        }

        @media ${devices.mobile} {
          display: grid;
          justify-items: flex-start;
          margin-left: 16px;
          row-gap: 24px;
          a {
            white-space: break-spaces;
          }
        }

        a {
          font-family: koerber, Arial, sans-serif;
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          line-height: 100%;
        }
      }
    }

    &__separator {
      position: absolute;
      height: 1px;
      border-width: 0px;
      background: ${colors.white};
      opacity: 0.32;
      left: 0;
      width: -webkit-fill-available;
    }

    &__copyrights {
      min-height: 118px;
      display: flex;
      flex-wrap: wrap;
      margin-right: auto;
      margin-left: auto;
      max-width: ${sizes.desktop - 1}px;
      padding: 40px 0px 64px;
      @media ${devices.tabletLarge} {
        padding: 36px 48px 56px 48px;
      }

      @media ${devices.mobile} {
        padding: 32px 24px 47px 24px;
      }

      p {
        color: ${colors.white};
        opacity: 0.72;

        font-family: koerber, Arial, sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 100%;
      }
    }
  }
  
  .scroll {
    position: relative;

    .scroll-container {
      position: absolute;
      width: 100%;
      height: 100%;
      max-width: 1512px;
      left: 0;
      right: 0;
      top: -48px;
      margin-right: auto;
      margin-left: auto;
      pointer-events: none;
        
      .footer-scroll {
        display: flex;
        position: absolute;
        width: 1px;
        left: 0;
        height: ${props => props.heightInnerContent + 110}px; // 115 = margin bottom + language font size + negative position
        background-color: rgba(255,255,255,0.32);
        
        @media ${devices.tabletLarge} {
          height: ${props => props.heightInnerContent + 108}px;
        }
        
        @media ${devices.mobile} {
          height: ${props => props.heightInnerContent + 104}px;
        }
        
        
        .scroll-indicator {
          height: 48px;
          width: 3px;
          position: absolute;
          top: ${props => props.scrollDistance}%;
          transform: translate3d(0, -100%, 0);
          left: -1px;
          z-index: 1;
          background-color: ${colors.blue};
          transition: top 0.3s ease-out;
        }
      }
    }
  }
`;

export { FooterBar };
